import React, { useEffect } from 'react';

const CkTextEditorStyles = ({ lineHeight = 1.6, fontSize = 16, editorTheme = 'light' }) => {
  useEffect(() => {
    // Create or update the dynamic styles
    const styleId = 'ck-text-editor-dynamic-styles';
    let styleElement = document.getElementById(styleId);
    
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = styleId;
      document.head.appendChild(styleElement);
    }
    
    styleElement.textContent = `
      [contenteditable]:empty:before {
        content: attr(data-placeholder);
        color: #9ca3af;
        pointer-events: none;
      }

      [contenteditable] {
        line-height: ${lineHeight};
        font-size: ${fontSize}px;
        color: ${editorTheme === "dark" ? "#e2e8f0" : "#374151"};
        background-color: ${editorTheme === "dark" ? "#1e293b" : "#ffffff"};
        transition: all 0.3s ease;
      }

  [contenteditable].reading-mode {
    background-color: ${editorTheme === "dark" ? "#0f172a" : "#fefefe"};
    max-width: 800px;
    margin: 0 auto;
    padding: 32px;
    line-height: 1.8;
    font-size: ${fontSize + 2}px;
  }

  [contenteditable] blockquote {
    border-left: 4px solid #3b82f6;
    padding: 16px 20px;
    margin: 1rem 0;
    font-style: italic;
    color: ${editorTheme === "dark" ? "#cbd5e1" : "#64748b"};
    background-color: ${editorTheme === "dark" ? "#334155" : "#f8fafc"};
    border-radius: 0 8px 8px 0;
  }

  [contenteditable] pre {
    background-color: ${editorTheme === "dark" ? "#0f172a" : "#1e293b"};
    color: ${editorTheme === "dark" ? "#f1f5f9" : "#e2e8f0"};
    padding: 1rem;
    border-radius: 0.375rem;
    font-family: "Fira Code", "Monaco", "Consolas", monospace;
    overflow-x: auto;
    margin: 1rem 0;
    border: 1px solid ${editorTheme === "dark" ? "#475569" : "#334155"};
    font-size: 0.875rem;
    line-height: 1.5;
  }

  [contenteditable] img {
    max-width: 100%;
    height: auto;
    border-radius: 0.375rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    margin: 0.5rem 0;
    transition: all 0.2s ease;
    cursor: pointer;
    border: 2px solid transparent;
  }

  [contenteditable] img:hover {
    transform: scale(1.02);
    border-color: #3b82f6;
    box-shadow: 0 8px 12px -2px rgba(59, 130, 246, 0.3);
  }

  [contenteditable] a {
    color: #3b82f6;
    text-decoration: none;
    border-bottom: 1px solid transparent;
    transition: all 0.2s ease;
  }

  [contenteditable] a:hover {
    color: #1d4ed8;
    border-bottom-color: #3b82f6;
  }

  [contenteditable] ul {
    padding-left: 2rem;
    margin: 1rem 0;
    list-style-type: disc;
    list-style-position: outside;
  }

  [contenteditable] ol {
    padding-left: 2rem;
    margin: 1rem 0;
    list-style-type: decimal;
    list-style-position: outside;
  }

  [contenteditable] ul ul {
    list-style-type: circle;
  }

  [contenteditable] ul ul ul {
    list-style-type: square;
  }

  [contenteditable] li {
    margin: 0.25rem 0;
    line-height: 1.6;
    display: list-item;
  }

  [contenteditable] table {
    border-collapse: collapse;
    width: 100%;
    margin: 1rem 0;
    border: 1px solid ${editorTheme === "dark" ? "#475569" : "#d1d5db"};
    border-radius: 0.375rem;
    overflow: hidden;
    background-color: ${editorTheme === "dark" ? "#334155" : "#ffffff"};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  [contenteditable] table th,
  [contenteditable] table td {
    padding: 0.75rem;
    border: 1px solid ${editorTheme === "dark" ? "#475569" : "#d1d5db"};
    text-align: left;
    transition: background-color 0.2s ease;
  }

  [contenteditable] table th {
    background-color: ${editorTheme === "dark" ? "#475569" : "#f3f4f6"};
    font-weight: 600;
    color: ${editorTheme === "dark" ? "#f1f5f9" : "#374151"};
  }

  [contenteditable] table tr:nth-child(even) {
    background-color: ${editorTheme === "dark" ? "#3f4b5b" : "#f9fafb"};
  }

  [contenteditable] table tr:hover {
    background-color: ${editorTheme === "dark" ? "#4a5568" : "#f3f4f6"};
  }

  [contenteditable] table td:hover {
    background-color: ${editorTheme === "dark" ? "#5a6478" : "#e5e7eb"};
    cursor: pointer;
  }

  [contenteditable] h1,
  [contenteditable] h2,
  [contenteditable] h3,
  [contenteditable] h4,
  [contenteditable] h5,
  [contenteditable] h6 {
    font-weight: bold;
    margin: 1.5rem 0 0.75rem 0;
    line-height: 1.2;
    color: ${editorTheme === "dark" ? "#f1f5f9" : "#1f2937"};
  }

  [contenteditable] h1 {
    font-size: 2rem;
    border-bottom: 2px solid ${editorTheme === "dark" ? "#475569" : "#e5e7eb"};
    padding-bottom: 0.5rem;
  }
  [contenteditable] h2 {
    font-size: 1.5rem;
    border-bottom: 1px solid ${editorTheme === "dark" ? "#475569" : "#e5e7eb"};
    padding-bottom: 0.25rem;
    color: ${editorTheme === "dark" ? "#e2e8f0" : "#374151"};
  }
  [contenteditable] h3 {
    font-size: 1.25rem;
    color: ${editorTheme === "dark" ? "#cbd5e1" : "#4b5563"};
  }
  [contenteditable] h4 {
    font-size: 1.125rem;
  }
  [contenteditable] h5 {
    font-size: 1rem;
  }
  [contenteditable] h6 {
    font-size: 0.875rem;
    color: ${editorTheme === "dark" ? "#94a3b8" : "#6b7280"};
  }

  [contenteditable] p {
    margin: 0.75rem 0;
    line-height: ${lineHeight};
  }

  [contenteditable] sub {
    vertical-align: sub;
    font-size: 0.75em;
  }

  [contenteditable] sup {
    vertical-align: super;
    font-size: 0.75em;
  }

  [contenteditable] mark {
    background-color: #fef08a;
    color: #92400e;
    padding: 0.125rem 0.25rem;
    border-radius: 0.25rem;
  }

  [contenteditable]:focus {
    outline: none;
  }

  [contenteditable] *:focus {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
  }

  [contenteditable] * {
    transition: color 0.2s ease, background-color 0.2s ease;
  }

  [contenteditable] strong {
    color: ${editorTheme === "dark" ? "#f1f5f9" : "inherit"};
  }

  [contenteditable] em {
    color: ${editorTheme === "dark" ? "#cbd5e1" : "inherit"};
  }

  /* Selection styling */
  [contenteditable]::selection {
    background-color: ${editorTheme === "dark" ? "#1e40af" : "#dbeafe"};
    color: ${editorTheme === "dark" ? "#f1f5f9" : "#1e40af"};
  }

  /* Collaborative cursor */
  .collaboration-cursor {
    position: absolute;
    width: 2px;
    background-color: #3b82f6;
    animation: blink 1s infinite;
  }

  @keyframes blink {
    0%,
    50% {
      opacity: 1;
    }
    51%,
    100% {
      opacity: 0;
    }
  }

  /* Auto-save indicator */
  .auto-save-indicator {
    position: fixed;
    top: 20px;
    right: 20px;
    padding: 8px 12px;
    background-color: #10b981;
    color: white;
    border-radius: 6px;
    font-size: 12px;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .auto-save-indicator.show {
    opacity: 1;
  }

  /* Print styles */
  @media print {
    [contenteditable] {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      background: white !important;
      color: black !important;
      font-size: 12pt;
      line-height: 1.5;
    }

    [contenteditable] a {
      color: black !important;
      text-decoration: underline;
    }

    [contenteditable] table {
      background: white !important;
    }

    [contenteditable] table th,
    [contenteditable] table td {
      background: white !important;
      color: black !important;
      border-color: black !important;
    }
  }

  /* Responsive table */
  @media (max-width: 768px) {
    [contenteditable] table {
      font-size: 0.875rem;
    }

    [contenteditable] table th,
    [contenteditable] table td {
      padding: 0.5rem;
    }
  }
    `;
    
    return () => {
      // Cleanup function to remove styles when component unmounts
      const styleElement = document.getElementById(styleId);
      if (styleElement) {
        styleElement.remove();
      }
    };
  }, [lineHeight, fontSize, editorTheme]);
  
  return null;
};

export default CkTextEditorStyles;
